import {
    useMemo,
} from 'react'

import useLabel from 'app/hooks/useLabel'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import Card from 'app/shared-components/Card'
import requests from 'app/requests/Order/Order.requests'
import {
    CustomerTransportTableType,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'

import getColumns from './RelatedOrdersTable.columns'
import useStyles from './relatedOrdersTable.styles'

const RelatedOrdersTable = ({
    longTermLeaseId,
}: { longTermLeaseId: number }) => {
    const l = useLabel()

    const {
        classes,
        cx,
    } = useStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()

    const columns = useMemo(() => {
        return getColumns({
            l,
        })
    }, [l])

    const urlConfig = useMemo(() => {
        const url = requests.allCustomerTransport({
            data: {
                includeFilters: {
                    longTermLeaseId: [longTermLeaseId],
                },
            },
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'Order',
        }
    }, [longTermLeaseId])

    const load: (params: any) => Promise<{
        items: CustomerTransportTableType,
        matches: number
    }> = useLoadDtoForSkyNetTable(urlConfig)

    return (
        <Card
            title="Related Orders"
            className={cardClasses.root}
        >
            <RichTable
                configName="RelatedOrdersTable"
                name="RelatedOrders"
                load={load}
                columns={columns}
                filter={{
                    longTermLeaseId: [longTermLeaseId],
                }}
                className={cx(tableClasses.tableContent, classes.table)}
                classNames={{
                    contentWrapper: tableClasses.tableContentWrapper,
                }}
                uniqField="id"
            />
        </Card>
    )
}

export default RelatedOrdersTable
